import dashboardAPI from './dashboard.api';

export { dashboardAPI };
export default dashboardAPI;
